import PropTypes from 'prop-types';
import React from 'react';

import classNames from 'classnames';
import * as OrganizationConstants from 'orgs/OrganizationConstants';

const OrgElement = ({onOrganizationClick, organization, selectedOrganizationId}) => {
  function _handleClick() {
    onOrganizationClick(organization);
  }
  const isSelected = selectedOrganizationId === organization.id;
  return (
    <button
      onClick={_handleClick}
      className={classNames('button button--large orgList-org-element-button', {
        'orgList-org-element-button-selected': isSelected,
        'orgList-org-element-button-not-selected': !isSelected,
      })}
      type="button"
    >
      {organization.name}
    </button>
  );
};

OrgElement.propTypes = {
  selectedOrganizationId: PropTypes.string,
  onOrganizationClick: PropTypes.func.isRequired,
  organization: OrganizationConstants.ORGANIZATION.isRequired,
};

const OrgList = (props) => (
  <div className="orgList-container">
    {props.organizations.map((organization, i) => (
      <OrgElement
        key={organization.id}
        organization={organization}
        onOrganizationClick={props.onOrganizationSelected}
        selectedOrganizationId={props.selectedOrganizationId}
      />
    ))}
  </div>
);

OrgList.propTypes = {
  selectedOrganizationId: PropTypes.string,
  organizations: PropTypes.arrayOf(OrganizationConstants.ORGANIZATION),
  onOrganizationSelected: PropTypes.func.isRequired,
};

export default OrgList;
